import { Model } from '@/models/Model';
export class GoalPlannerTimeslot extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GoalPlannerTimeslot';
        this.$endpoint = '/goal-planner-timeslots';
        this.$fillable = ['title', 'day', 'starts_at', 'ends_at'];
    }
}
